import FacetContainer from 'components/Directories/SearchFacetsContainer/FacetContainer'

const FacetsContainer = ({ facetGroups, selectedFacets, directoryLinkInformation }) => {
  if (!facetGroups) {
    return null
  }
  return (
    facetGroups &&
    facetGroups.length > 0 &&
    facetGroups.map((facet, i) => (
      <FacetContainer
        key={i}
        directoryLinkInformation={directoryLinkInformation}
        facetGroup={facet}
        selectedFacets={selectedFacets || []}
      />
    ))
  )
}

export default FacetsContainer
